import { Injectable, inject } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs';
import { datadogRum } from '@datadog/browser-rum';

import { NativeBridgeService } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';
import { MultivariateTestService } from '@fcom/common/multivariate-test/services/multivariate-test.service';

@Injectable({ providedIn: 'root' })
export class DatadogContextService {
  private nativeBridge = inject(NativeBridgeService);
  private language = inject(LanguageService);
  private multivariateTest = inject(MultivariateTestService);

  /**
   * Attaches cross-cutting attributes to every RUM event so they can be faceted in Datadog. Keeps
   * them current as the customer switches language or their A/B segment resolves.
   */
  trackGlobalContext(): void {
    datadogRum.setGlobalContextProperty('native_webview', this.nativeBridge.isInsideNativeWebView);

    this.language.locale
      .pipe(distinctUntilChanged())
      .subscribe((locale) => datadogRum.setGlobalContextProperty('locale', locale));

    this.language.lang
      .pipe(distinctUntilChanged())
      .subscribe((language) => datadogRum.setGlobalContextProperty('language', language));

    this.multivariateTest.segmentsFeed$
      .pipe(
        map((variant) => variant.segment),
        distinctUntilChanged()
      )
      .subscribe((segment) => datadogRum.setGlobalContextProperty('ab_segment', segment));
  }
}
